// components
import { Footer, Navbar } from "@components/Common"
// helpers
import { cn } from "src/utils/common.helper"

const DefaultLayout = (props) => {
    const {
        children,
        layoutClassName = "",
        wrapperClassName = "",
        contentClassName = "",
        hideFooter = false,
    } = props

    return (
        <div
            className={cn(
                "flex flex-col justify-between relative min-h-svh w-full bg-[var(--pure-white)] overflow-hidden",
                layoutClassName
            )}
        >
            <div
                className={cn(
                    "flex flex-col flex-grow overflow-hidden",
                    wrapperClassName
                )}
            >
                <Navbar />
                <div
                    className={cn(
                        "flex flex-col gap-5 lg:gap-6 3xl:gap-10 overflow-hidden flex-grow w-full",
                        contentClassName
                    )}
                >
                    {children}
                </div>
            </div>
            {!hideFooter && <Footer />}
        </div>
    )
}

export default DefaultLayout
